// ปุ่มเลือกช่วงเวลาของแต่ละบล็อก
//
// ทุกบล็อกมีช่วงของตัวเอง — สี่แหล่งอัปเดตไม่พร้อมกันและรองรับช่วงไม่เหมือนกัน
// (Ads ของ Biddable มี preset ถึง 30 วัน/รายเดือน · KOL เป็นจำนวนวันตรง ๆ)
// ตัวเดียวคุมทั้งหน้าจะทำให้ตัวเลขบางใบไม่ตรงกับป้ายที่เขียนไว้
import { cn } from "@shared/lib/utils";

export type RangeOption<T> = { v: T; label: string };

export function RangePills<T extends string | number>({
  options,
  value,
  onPick,
}: {
  options: RangeOption<T>[];
  value: T;
  onPick: (v: T) => void;
}) {
  return (
    <div className="range-pills">
      {options.map((o) => (
        <button
          key={String(o.v)}
          type="button"
          className={cn("pill", o.v === value && "active")}
          onClick={() => onPick(o.v)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
